import { axios } from "../config/axios";

const endPoint = '/project/reports';

const getAttendanceDataReport = async (body) => {
    return axios.post(`${endPoint}/attendance-data-report`, body);
}

const downloadAttendanceDataReport = async (body) => {
    return axios.post(`${endPoint}/download-attendance-data-report`, body, {
        responseType: 'blob',
    });
}

const getCandidateResultReport = async (body) => {
    return axios.post(`${endPoint}/candidate-result-report`, body);
}

const downloadCandidateResultReport = async (body) => {
    return axios.post(`${endPoint}/download-candidate-result-report`, body, {
        responseType: 'blob',
    });
}

const getCandidateResponseSheet = async (body) => {
    return axios.post(`${endPoint}/candidate-response-sheet`, body);
}

const downloadCandidateResponseSheet = async (body) => {
    return axios.post(`${endPoint}/download-candidate-response-sheet`, body, {
        responseType: 'blob',
    });
}

export {
    getAttendanceDataReport,
    downloadAttendanceDataReport,
    getCandidateResultReport,
    downloadCandidateResultReport,
    getCandidateResponseSheet,
    downloadCandidateResponseSheet,
}